import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
const Mrp2Valvs = "mrp2Valvs/api/v1/";
const Sply = "sply/api/v1/";

export default {
  // InspectionLevel Actions ------------------------------------------------------------------
  getInspectionLevel({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/InspectionLevel")
      .then((res) => {
        commit("setInspectionLevel", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getInspectionLevelCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "basic/InspectionLevel/MaxCode")
      .then((res) => {
        commit("setInspectionLevelCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addInspectionLevel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/InspectionLevel", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editInspectionLevel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/InspectionLevel/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteInspectionLevel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/InspectionLevel", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ProductionGroups Actions ------------------------------------------------------------------
  getProductionGroups({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/ProductionGroup")
      .then((res) => {
        commit("setProductionGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProductionGroup({ dispatch, commit }, data) {
    axios
      .get(Mrp2Valvs + "basic/ProductionGroup/" + data)
      .then((res) => {
        commit("setProductionGroup", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductionGroupsCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "basic/ProductionGroup/MaxCode")
      .then((res) => {
        commit("setProductionGroupsCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProductionGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/ProductionGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProductionGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/ProductionGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProductionGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/ProductionGroup", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // CommodityAdditionalInfo Actions ------------------------------------------------------------------
  getCommodityAdditionalInfo({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/CommodityAdditionalInfo?" + data)
      .then((res) => {
        commit("setCommodityAdditionalInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // نتیجه و شناسه رکورد را برمی‌گرداند تا فایل با همان شناسه در فایلینگ آپلود شود
  addCommodityAdditionalInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(Mrp2Valvs + "basic/CommodityAdditionalInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return { ok: res.status === 200, id: res.data.data || null };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false, id: null };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // نتیجه را برمی‌گرداند تا فایل بعد از ویرایش در فایلینگ آپلود شود
  editCommodityAdditionalInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(Mrp2Valvs + "basic/CommodityAdditionalInfo/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return { ok: res.status === 200, id: data.id };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false, id: null };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCommodityAdditionalInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/CommodityAdditionalInfo", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ProductionGroupSupplier Actions ------------------------------------------------------------------
  getProductionGroupSupplier({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/ProductionGroupSupplier")
      .then((res) => {
        commit("setProductionGroupSupplier", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProductionGroupSupplierCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "basic/ProductionGroupSupplier/MaxCode")
      .then((res) => {
        commit("setProductionGroupSupplierCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProductionGroupSupplier({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/ProductionGroupSupplier", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProductionGroupSupplier({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/ProductionGroupSupplier/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProductionGroupSupplier({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/ProductionGroupSupplier", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // PurchaseContracts Actions ------------------------------------------------------------------
  getPurchaseContracts({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/PurchaseContract")
      .then((res) => {
        commit("setPurchaseContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPurchaseContractsCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "basic/PurchaseContract/MaxCode")
      .then((res) => {
        commit("setPurchaseContractsCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPurchaseContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/PurchaseContract", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPurchaseContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/PurchaseContract/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePurchaseContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/PurchaseContract", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // SaleTypes Actions ------------------------------------------------------------------
  getSaleTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/SaleType")
      .then((res) => {
        commit("setSaleTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleTypesCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "basic/SaleType/MaxCode")
      .then((res) => {
        commit("setSaleTypesCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/SaleType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/SaleType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/SaleType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // StopStations Actions ------------------------------------------------------------------
  getStopStations({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/StopStation")
      .then((res) => {
        commit("setStopStations", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getStopStationsCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "basic/StopStation/MaxCode")
      .then((res) => {
        commit("setStopStationsCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addStopStation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/StopStation", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editStopStation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/StopStation/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteStopStation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/StopStation", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Orders Actions ------------------------------------------------------------------
  getOrders({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Order")
      .then((res) => {
        commit("setOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getOrder({ dispatch, commit }, data) {
    axios
      .get(Mrp2Valvs + "operation/Order/" + data)
      .then((res) => {
        commit("setOrder", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrdersCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "operation/Order/MaxCode")
      .then((res) => {
        commit("setOrdersCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "operation/Order", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PMRPVALVSOrderList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Order/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "operation/Order", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // تکمیل سفارش؛ سفارش باطل‌شده تکمیل نمی‌شود
  completeOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Order/Complete", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // OrderAttachment Actions ------------------------------------------------------------------
  getOrderCommodityAttachment({ dispatch, commit }, data) {
    axios
      .get(Mrp2Valvs + "operation/OrderCommodityAttachment?" + data)
      .then((res) => {
        commit("setOrderCommodityAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // نتیجه و شناسه نوبت پیوست را برمی‌گرداند تا فایل با همان شناسه در فایلینگ آپلود شود
  addOrderCommodityAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(Mrp2Valvs + "operation/OrderCommodityAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return { ok: res.status === 200, id: res.data.data || null };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false, id: null };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editOrderCommodityAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        Mrp2Valvs + "operation/OrderCommodityAttachment/" + data.id,
        data.value
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOrderAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    // پرامیس برمی‌گردد تا فراخوان بتواند فهرست را دوباره بخواند
    return axios
      .delete(Mrp2Valvs + "operation/OrderCommodityAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // OrderDataSheet Actions ------------------------------------------------------------------
  getOrderDataSheets({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/OrderDataSheet")
      .then((res) => {
        commit("setOrderDataSheets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getOrderDataSheet({ dispatch, commit }, data) {
    axios
      .get(Mrp2Valvs + "operation/OrderDataSheet/" + data)
      .then((res) => {
        commit("setOrderDataSheet", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOrderDataSheetCode({ dispatch, commit }) {
    axios
      .get(Mrp2Valvs + "operation/OrderDataSheet/MaxCode")
      .then((res) => {
        commit("setOrderDataSheetCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addOrderDataSheet({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "operation/OrderDataSheet", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editOrderDataSheet({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/OrderDataSheet/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOrderDataSheet({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "operation/OrderDataSheet", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Setting Actions ------------------------------------------------------------------
  getSettings({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "basic/Setting")
      .then((res) => {
        commit("setSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Cartable Actions ------------------------------------------------------------------
  getTechnicalCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/TechnicalCartable")
      .then((res) => {
        commit("setTechnicalCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // نتیجه و شناسه نوبت پیوست را برمی‌گرداند تا فایل با همان شناسه در فایلینگ آپلود شود
  approveTechnicalCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(Mrp2Valvs + "operation/Cartable/ApproveConfirmTechnical", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return { ok: res.status === 200, id: res.data.data || null };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false, id: null };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getMapConfirmCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/ConfirmCartable")
      .then((res) => {
        commit("setMapConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  approveMapConfirmCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Cartable/ApproveConfirmPlan", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getInventoryControlCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/InventoryControlCartable")
      .then((res) => {
        commit("setInventoryControlCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  approveInventoryControl({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Cartable/ApproveInventoryControl", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getDeliveryDateCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/DeliveryDateCartable")
      .then((res) => {
        commit("setDeliveryDateCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  deliveryDateConfirmCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Cartable/AddDeliveryDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getConfirmDeliveryDateCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/ConfirmDeliveryDateCartable")
      .then((res) => {
        commit("setConfirmDeliveryDateCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  confirmDeliveryDate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Cartable/ConfirmDeliveryDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getNeedPlanCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/IsNeedPlanCartable")
      .then((res) => {
        commit("setIsNeedPlanCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // نتیجه و شناسه نوبت پیوست را برمی‌گرداند تا فایل با همان شناسه در فایلینگ آپلود شود
  isNeedPlan({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(Mrp2Valvs + "operation/Cartable/IsNeedPlan", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return { ok: res.status === 200, id: res.data.data || null };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false, id: null };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSellCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/Cartable/SellCartable")
      .then((res) => {
        commit("setSellCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // نتیجه و شناسه نوبت پیوست را برمی‌گرداند تا فایل با همان شناسه در فایلینگ آپلود شود
  sellCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(Mrp2Valvs + "operation/Cartable/Sell", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return { ok: res.status === 200, id: res.data.data || null };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false, id: null };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBomProduction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/Cartable/AddBom", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Bom.......................................................................................
  getBom({ dispatch, commit }, data) {
    axios
      .get(Mrp2Valvs + "basic/Bom/" + data)
      .then((res) => {
        commit("setBoms", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getBomCommodities({ dispatch, commit }, data) {
    axios
      .get(Sply + "basic/BomMaterial?bomId=" + data)
      .then((res) => {
        commit("setBomCommodities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBom({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/Bom/AggregateMaterial", data)
      .then((res) => {
        commit("setBoms", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // OrderCommodityReservation Actions ------------------------------------------------------------------
  getOrderCommodityReservation({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(Mrp2Valvs + "operation/OrderCommodity/Reservation")
      .then((res) => {
        commit("setOrderCommodityReservation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  editOrderCommodityReservation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "operation/OrderCommodity", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOrderCommodityReservation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/PurchaseContract", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // CommodityInventoryGroupByWare Actions ------------------------------------------------------------------
  getCommodityInventoryWare({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(
        Mrp2Valvs +
          "basic/CommodityAdditionalInfo/CommodityInventoryGroupByWare?" +
          data
      )
      .then((res) => {
        commit("setCommodityInventoryWare", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // OrderCommodityStatusLog Actions ------------------------------------------------------------------
  getOrderCommodityStatusLogs({ dispatch, commit }, data) {
    axios
      .get(Mrp2Valvs + "operation/OrderCommodityStatusLog?" + data)
      .then((res) => {
        commit("setOrderCommodityStatusLogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReqBuy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "operation/BuyRequest", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.data.item1,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ModiranMapping Actions ------------------------------------------------------------------
  // kind اختیاری است؛ اگر ندهید هر دو نوع نگاشت برمی‌گردد
  getModiranMappings({ dispatch, commit }, kind) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get(
        Mrp2Valvs + "basic/ModiranMapping" + (kind ? "?kind=" + kind : "")
      )
      .then((res) => {
        commit("setModiranMappings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // این اندپوینت زنده به سیستم مدیران وصل می‌شود و ممکن است کند باشد یا خطا بدهد؛
  // خطا را به‌جای تُست سراسری در state نگه می‌داریم تا فقط داخل مودال نشان داده شود
  // و گرید نگاشت‌های موجود نشکند.
  getModiranSide({ commit }, kind) {
    commit("setModiranSideLoading", true);
    commit("setModiranSideError", null);
    return axios
      .get(Mrp2Valvs + "basic/ModiranMapping/modiranSide/" + kind)
      .then((res) => {
        if (res.data && res.data.isSuccess === false) {
          commit("setModiranSideError", res.data.message || null);
          return;
        }
        if (kind === "Ware") {
          commit("setModiranSideWares", res.data.data || []);
        } else {
          commit("setModiranSideVoucherTypes", res.data.data || []);
        }
      })
      .catch((error) => {
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : null;
        commit("setModiranSideError", message);
      })
      .finally(() => {
        commit("setModiranSideLoading", false);
      });
  },

  addModiranMapping({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(Mrp2Valvs + "basic/ModiranMapping", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editModiranMapping({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "basic/ModiranMapping/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // بدنه‌ی DELETE آرایه‌ای از Guid است و باید در data بیاید؛ id تکراری هم
  // باعث خطای «یافت نشد» سرور می‌شود، پس یکتا می‌شود.
  deleteModiranMapping({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(Mrp2Valvs + "basic/ModiranMapping", {
        data: [...new Set(data)],
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDeliveryDate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(Mrp2Valvs + "operation/OrderCommodity/DeliveryDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
